<template lang="pug">
  .component-backoffice-category-list.row.column

    button.button(v-if="previouslySaved", @click="loadPreviouslySaved") Load previously saved
    textarea(rows="20", v-model="body",  style="font-family: monospace;")
    ActionButton(:action="save") Save

</template>

<script>
import GoogleMap from '../../lib/map/GoogleMap'
import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
import BaseList from './BaseList'
import ModalReveal from "../../components/structure/foundation/ModalReveal.vue";
import {mapState} from "vuex";
import collect from "collect.js";
import ActionButton from "../../components/structure/ui/ActionButton.vue";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import MaggieHelper from "../../maggieHelper";

export default {
  name: 'SplashList',
  components: {ActionButton, ModalReveal, BaseList, GoogleMap, GoogleMapPolygon},
  data() {
    return {
      body: ""
    }
  },
  created() {
    this.body = JSON.stringify(this.getPreset.splash, null, 2)
  },
  methods: {
    save() {
      return KeplerBackofficeSdk.splash.make(JSON.parse(this.body), () => {
        localStorage.setItem('splash', this.body)
        MaggieHelper.notification('splash', 'updated')
      })
    },
    usePreset() {
      this.body = JSON.stringify(this.getPreset.splash, null, 2)
    },
    loadPreviouslySaved() {
      this.body = this.previouslySaved

    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    languages() {
      const systemFields = collect(this.configuration.system.system_fields_configuration.value);

      let config = systemFields.first((i) => i.field === 'allowedLanguages');
      if (config.field === 'allowedLanguages') {
        return collect(this.configuration.system.system_fields_configuration.value).first((i) => i.field === 'allowedLanguages').config.split(',')
      }

      return [this.configuration.application.application_default_language.value]
    },
    previouslySaved() {
      return localStorage.getItem('splash')
    },
    getPreset() {
      let availableLanguages = () => {

        let lang = this.languages
        let languages = {}

        lang.forEach((val) => {
          languages[val] = ""
        })

        return languages
      }

      return {
        splash: {
          title: availableLanguages(),
          description: availableLanguages(),
          elements: [
            {
              color: "",
              title: availableLanguages(),
              description: availableLanguages(),
              icon: "",
              action: "",
              options: ""
            }
          ]
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
.component-backoffice-zone-list
  .map
    height: 400px

  .zone-edit
    color: white

</style>



// WEBPACK FOOTER //
// SplashConfigList.vue?4b7c283e